import api from '@/store/api/cancellation'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    cancellation: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        cancellation: state => state.cancellation
    },
    actions: {
        /**
         * @param {{cancellationId: number}} data
         * @returns {Promise<*>}
         */
        showCancellation: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showCancellation(data)
                commit(mutationTypes.SET_CANCELLATION, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} data
         * @returns {Promise<*>}
         */
        updateCancellation: async ({dispatch}, data) => {
            try {
                const response = await api.updateCancellation(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetCancellation: async ({commit}) => commit(mutationTypes.RESET_CANCELLATION)
    },
    mutations: {
        [mutationTypes.SET_CANCELLATION]: (state, data) => state.cancellation = data,
        [mutationTypes.RESET_CANCELLATION]: (state) => Object.assign(state, initialState())
    }
}
